module.exports = __webpack_public_path__ + "static/logo-full-73d9f54673acbafc4d962422c35cfd27.svg";